import { SeatMapCabin } from "@duffel/api/types";

export const hasWings = (cabin: SeatMapCabin, rowIndex: number) =>
  Boolean(
    cabin.wings &&
      cabin.wings.first_row_index <= rowIndex &&
      cabin.wings.last_row_index >= rowIndex,
  );
;
import "/Users/andrejakogovsek/.yarn/berry/cache/@sentry-bundler-plugin-core-npm-0.7.2-054e3436fd-10c0.zip/node_modules/@sentry/bundler-plugin-core/sentry-release-injection-file.js";